export class User {
  static Empty(): User {
    return new User('', '', '');
  }

  id: string = '';
  name: string = '';
  email: string = '';
  isResendProcess: boolean = false;
  status: string | undefined = '';
  picture: string | undefined = '';

  constructor(userId: string, userName: string, userEmail: string, picture?: string, status?: string) {
    this.id = userId;
    this.name = userName;
    this.email = userEmail;
    this.status = status;
    this.picture = picture;

  }
}
